import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import info, { eventTypes } from './styles'

export default class extends PureComponent {
  static propTypes = {
    event: PropTypes.object
  }

  render() {
    const { event } = this.props
    return (
      <div className="content">
        {event && event.type === 'VALUATION' && <h4>{event.broker}</h4>}
        <h4 className="header highlight">Tipos de eventos</h4>
        <ul className="list">
          <li className="broker-valuation pending">
            <p>Citas de valuación</p>
            <p>pendientes</p>
          </li>
          <li className="custom-event confirmed">
            <p>Eventos</p>
          </li>
        </ul>
        <style jsx>{info}</style>
        <style jsx>{eventTypes}</style>
      </div>
    )
  }
}
